export default __webpack_public_path__ + "beta-maps-examples-user-location-view-1200-e4c09dc0447f66621553f9d523fd4385.webp";